/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module OverclockingnvcTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface OverClockingNvcplugin {
    [k: string]: any;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "SliderSetting".
 */
export interface SliderSetting {
    /**
     * Minimum range value
     */
    min?: number;
    /**
     * Maximum range value
     */
    max?: number;
    /**
     * current value of the slider
     */
    current?: number;
    /**
     * Absolute value of the object
     */
    absolute?: number;
    /**
     * default value of the slider
     */
    default?: number;
    type?: Type;
    /**
     * whether slider is supported on the system or not
     */
    isSupported?: boolean;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "FanSetting".
 */
export interface FanSetting {
    /**
     * Fan index
     */
    index?: number;
    /**
     * Whether Fan is user contolled ot hardware controlled
     */
    autoPower?: boolean;
    /**
     * If fan control is Visible on current system
     */
    isVisible?: boolean;
    sliderSetting?: SliderSetting;
}
/**
 * Offset of one editable graphics V/F point in kHz.
 *
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "ManualOCProfileVfPointOffset".
 */
export interface ManualOCProfileVfPointOffset {
    vfPointIndex: number;
    frequencyOffsetKHz: number;
}
/**
 * Target of one supported limiter (units as ManualOCLimiterState).
 *
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "ManualOCProfileLimiter".
 */
export interface ManualOCProfileLimiter {
    type: ManualOcLimiterType;
    value: number;
}
/**
 * Scalar fan target of one physical fan.
 *
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "ManualOCProfileFan".
 */
export interface ManualOCProfileFan {
    index: number;
    autoPower: boolean;
    powerPercent: number;
}
/**
 * Complete supported-domain snapshot.
 *
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "ManualOCProfileDraft".
 */
export interface ManualOCProfileDraft {
    graphicsVfOffsets: ManualOCProfileVfPointOffset[];
    memoryOffsetKHz?: number;
    limiters: ManualOCProfileLimiter[];
    fans: ManualOCProfileFan[];
}
/**
 * Outcome of one requested domain; fanIndex is present for the Fan domain only (one entry per fan).
 *
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "ManualOCApplyDomainResult".
 */
export interface ManualOCApplyDomainResult {
    domain: ManualOcApplyDomain;
    status: ManualOcApplyStatus;
    fanIndex?: number;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "SetManualOCLimitsParameters".
 */
export interface SetManualOCLimitsParameters {
    uiGpuId: number;
    sliders?: SliderSetting[];
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "SetManualOCLimitsReturn".
 */
export interface SetManualOCLimitsReturn {
    /**
     * true if successfully set otherwise false
     */
    result: boolean;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "StartOcManualScanParameters".
 */
export interface StartOcManualScanParameters {
    uiGpuId: number;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "StartOcManualScanReturn".
 */
export interface StartOcManualScanReturn {
    /**
     * true if successfully set otherwise false
     */
    result: boolean;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "StopOcManualScanParameters".
 */
export interface StopOcManualScanParameters {
    uiGpuId: number;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "StopOcManualScanReturn".
 */
export interface StopOcManualScanReturn {
    /**
     * true if successfully set otherwise false
     */
    result: boolean;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "EnableBackgroundOcScanParameters".
 */
export interface EnableBackgroundOcScanParameters {
    uiGpuId: number;
    enable: boolean;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "EnableBackgroundOcScanReturn".
 */
export interface EnableBackgroundOcScanReturn {
    /**
     * true if successfully set otherwise false
     */
    result: boolean;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "EnableAutotuneOcParameters".
 */
export interface EnableAutotuneOcParameters {
    uiGpuId: number;
    enable: boolean;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "EnableAutotuneOcReturn".
 */
export interface EnableAutotuneOcReturn {
    /**
     * true if successfully set otherwise false
     */
    result: boolean;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "RestoreOcDefaultParameters".
 */
export interface RestoreOcDefaultParameters {
    uiGpuId: number;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "RestoreOcDefaultReturn".
 */
export interface RestoreOcDefaultReturn {
    /**
     * true if successfully set otherwise false
     */
    result: boolean;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "SetFanSettingsParameters".
 */
export interface SetFanSettingsParameters {
    uiGpuId: number;
    fanSettings?: FanSetting[];
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "SetFanSettingsReturn".
 */
export interface SetFanSettingsReturn {
    /**
     * true if successfully set otherwise false
     */
    result: boolean;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "SetPerfProfileParameters".
 */
export interface SetPerfProfileParameters {
    uiGpuId: number;
    profile: Profile;
    sliders?: SliderSetting[];
    fanSettings?: FanSetting[];
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "SetPerfProfileReturn".
 */
export interface SetPerfProfileReturn {
    /**
     * true if successfully set otherwise false
     */
    result: boolean;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "SaveManualOCProfileParameters".
 */
export interface SaveManualOCProfileParameters {
    uiGpuId: number;
    slot: number;
    draft: ManualOCProfileDraft;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "SaveManualOCProfileReturn".
 */
export interface SaveManualOCProfileReturn {
    result: boolean;
    failure: ManualOcProfileFailure;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "ApplyManualOCParameters".
 */
export interface ApplyManualOCParameters {
    uiGpuId: number;
    selection: ManualOcSelection;
    slot?: number;
    draft?: ManualOCProfileDraft;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "ApplyManualOCReturn".
 */
export interface ApplyManualOCReturn {
    result: boolean;
    failure: ManualOcProfileFailure;
    /**
     * One entry per requested domain (fans one per fan) in apply order; empty when nothing was attempted
     */
    domainResults: ManualOCApplyDomainResult[];
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "DeleteManualOCProfileParameters".
 */
export interface DeleteManualOCProfileParameters {
    uiGpuId: number;
    slot: number;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "DeleteManualOCProfileReturn".
 */
export interface DeleteManualOCProfileReturn {
    result: boolean;
    failure: ManualOcProfileFailure;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "SetManualOCProfileRebootRestorePreferenceParameters".
 */
export interface SetManualOCProfileRebootRestorePreferenceParameters {
    uiGpuId: number;
    profileId: number;
    enabled: boolean;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "SetManualOCProfileRebootRestorePreferenceReturn".
 */
export interface SetManualOCProfileRebootRestorePreferenceReturn {
    result: boolean;
    failure: ManualOcProfileFailure;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "AcknowledgeManualOCStartupRecoveryMessageParameters".
 */
export interface AcknowledgeManualOCStartupRecoveryMessageParameters {
    uiGpuId: number;
}
/**
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "AcknowledgeManualOCStartupRecoveryMessageReturn".
 */
export interface AcknowledgeManualOCStartupRecoveryMessageReturn {
    result: boolean;
    failure: ManualOcProfileFailure;
}

/**
 * Type of the slider
 */
export enum Type {
    Unknown = 0,
    GpuClock = 1,
    MemoryClock = 2,
    Voltage = 3,
    Power = 4,
    Temperature = 5,
    Fan = 6
}
/**
 * Failure code shared by the Manual OC state and profile commands.
 *
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "ManualOCProfileFailure".
 */
export enum ManualOcProfileFailure {
    None = 0,
    ConsentDenied = 1,
    AutomaticOCActive = 2,
    DriverStateUnavailable = 3,
    InvalidSlot = 4,
    SlotEmpty = 5,
    SnapshotInvalid = 6,
    ProfileIncompatible = 7,
    ProfileStorageError = 8,
    HardwareApplyFailed = 9,
    LiveStateMismatch = 10,
    ProfileIdentityUnavailable = 11,
    StartupRestoreUnsupported = 12,
    InvalidGpu = 13,
    InvalidRequest = 14
}
/**
 * Limiter identity; values match SliderSetting.type (3 Voltage, 4 Power, 5 Temperature).
 *
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "ManualOCLimiterType".
 */
export enum ManualOcLimiterType {
    Voltage = 3,
    Power = 4,
    Temperature = 5
}
/**
 * Tuning domain on the wire (0 Graphics, 1 Memory, 2 Voltage, 3 Power, 4 Temperature, 5 Fan).
 *
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "ManualOCApplyDomain".
 */
export enum ManualOcApplyDomain {
    GraphicsVf = 0,
    MemoryClock = 1,
    VoltageLimit = 2,
    PowerLimit = 3,
    TemperatureLimit = 4,
    Fan = 5
}
/**
 * What ApplyManualOC applies: 0 Default (accepts neither draft nor slot), 1 Custom (requires draft), 2 SavedSlot (requires slot).
 *
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "ManualOCSelection".
 */
export enum ManualOcSelection {
    Default = 0,
    Custom = 1,
    SavedSlot = 2
}
/**
 * Outcome of one requested domain: 0 Applied (the setter succeeded), 1 Failed (the setter or a read it needed failed).
 *
 * This interface was referenced by `OverClockingNvcplugin`'s JSON-Schema
 * via the `definition` "ManualOCApplyStatus".
 */
export enum ManualOcApplyStatus {
    Applied = 0,
    Failed = 1
}
/**
 * Type of the profile
 */
export enum Profile {
    Default = 0,
    Custom = 1,
    Silent = 2,
    MaxPerf = 3
}


}
